// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_yn7","cls2":"LettersModal-cls2_HoS LettersModal-cls1_yn7"};